export default __webpack_public_path__ + "static/media/pouce.a7920e84.png";